import { API_REQUEST } from '../../core/actions';
import * as API from '../../core/api/azure';
import { viewPermissionRefs } from '../../core/components/UserGroupPermissions';
import { ActionExternalCall, ActionInternalCall } from '../../utils/typing';

export const GET_REPORT = 'GET_REPORT';
export const SET_PERMISSION = 'SET_PERMISSION';
export const CLEAR_REPORT = 'CLEAR_REPORT';
export const SET_ANALYTICS_PAGE = 'SET_ANALYTICS_PAGE';
export const GET_VISUAL_REPORT = 'GET_VISUAL_REPORT';
export const GET_REWASH_VISUAL_REPORT = 'GET_REWASH_VISUAL_REPORT';
export const fetchReport = (
  safetyInterval: number,
  specificReport: string,
  isWashClub: boolean
): ActionExternalCall => {
  return {
    type: API_REQUEST,
    callAPI: API.fetchReport,
    action: GET_REPORT,
    data: { query: { specificReport } },
    meta: {
      id: 'id',
      safetyInterval,
      permissionKey: viewPermissionRefs.analytics,
      useManagerSiteId: !isWashClub,
      options: {
        reportName: specificReport,
      },
    },
  };
};

export const fetchVisualReport = (
  safetyInterval: number,
  specificReport: string,
  includeClosestSites: boolean,
  dashboardType?: string
): ActionExternalCall => {
  return {
    type: API_REQUEST,
    callAPI: API.fetchVisualReport,
    action: GET_VISUAL_REPORT,
    data: { query: { specificReport, includeClosestSites } },
    meta: {
      id: 'id',
      safetyInterval,
      permissionKey: viewPermissionRefs.analytics,
      useManagerSiteId: true,
      options: {
        specificReport,
        dashboardType: dashboardType || 'dashboard',
      },
    },
  };
};
export const fetchRewashVisualReport = (
  safetyInterval: number,
  specificReport: string,
  includeClosestSites: boolean
): ActionExternalCall => {
  return {
    type: API_REQUEST,
    callAPI: API.fetchVisualReport,
    action: GET_REWASH_VISUAL_REPORT,
    data: { query: { specificReport, includeClosestSites } },
    meta: {
      id: 'id',
      safetyInterval,
      permissionKey: viewPermissionRefs.analytics,
      useManagerSiteId: true,
      options: {
        specificReport,
      },
    },
  };
};
export const setPermissionLevel = (level: string): ActionInternalCall => {
  return { type: SET_PERMISSION, payload: level };
};

export const clearReport = (): ActionInternalCall => {
  return { type: CLEAR_REPORT };
};

export const setAnalyticsPage = (page: string): ActionInternalCall => {
  return { type: SET_ANALYTICS_PAGE, payload: page };
};
